import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkshop = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Workshop",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_956",
				"data-name": "Rectangle 956",
				width: 13.846,
				height: 20,
				transform: "translate(-7381 7229)",
				fill: "#fff"
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Mask_Group_13",
			"data-name": "Mask Group 13",
			transform: "translate(7386.077 -7227)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Icon_Workshop",
				"data-name": "Icon/Workshop",
				transform: "translate(-7381 7229)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_952",
						"data-name": "Rectangle 952",
						width: 13.846,
						height: 20,
						rx: 2,
						transform: "translate(0 0)",
						fill: "#f6f6f6"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_805",
						"data-name": "Path 805",
						d: "M.3.195H1.661V1.6h1.2v1.55h-1.2V4.66H.3V3.151H-.985V1.6H.3Z",
						transform: "translate(2.523 11.494)",
						fill: "#4d595a"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_953",
						"data-name": "Rectangle 953",
						width: 6.923,
						height: 19.231,
						rx: 3,
						transform: "translate(0.769 0)",
						fill: "rgba(254,166,39,0.44)"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_954",
						"data-name": "Rectangle 954",
						width: 10.769,
						height: 7.692,
						rx: 2,
						transform: "translate(1.538 0.769)",
						fill: "#fea627"
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_955",
						"data-name": "Rectangle 955",
						width: 1.538,
						height: .769,
						transform: "translate(8.462 13.846)",
						fill: "#4d595a"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_806",
						"data-name": "Path 806",
						d: "M0,.085H.525v-.5h.568v.5h.493v.59H1.092v.539H.525V.675H0Z",
						transform: "translate(11.515 13.018)",
						fill: "#4d595a"
					})
				]
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_958",
			"data-name": "Rectangle 958",
			width: 24,
			height: 24,
			fill: "rgba(255,255,255,0)"
		})
	]
});
export default SvgWorkshop;
